import { render, staticRenderFns } from "./childOrderDetail.vue?vue&type=template&id=534ab002"
import script from "./childOrderDetail.vue?vue&type=script&lang=js"
export * from "./childOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports